let AbstractGeocoder = require('./../abstractGeocoder');
let GoogleGeocodingItem = require('./googleGeocodingItem');
let axios = require('axios');

class GoogleGeocoder extends AbstractGeocoder {
   constructor(params) {
      super(params);
      this.params = params;

      const defaultKey = "AIzaSyDXcGeb0yTWkGpT8QxptiKHoZ8hDuunO0U";
      this.key = params.key || defaultKey;
      this.url = params.url || "https://maps.googleapis.com/maps/api/geocode/json?";
   }

   async geocode(location) {
      let self = this;
      let result = (await axios(self.url + "address=" + location + "&key="+self.key)).data;
      let items = result.results.map((item) => {
         return new GoogleGeocodingItem(item);
      });
      return items;
   }

   async reverseGeocode(coordinates) {
      let self = this;
      let results = (await axios(self.url + "latlng=" + coordinates[1]+", "+coordinates[0] + "&key="+self.key)).data;
      return results;
   }
}

module.exports = GoogleGeocoder;